import React, { useState } from "react";
import { AusPostIcon, InhouseParcelIcon } from "../Icon";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { globalTheme } from "../../styles";
import { InfoOutlined } from "@mui/icons-material";
import { Drawer } from "../Drawer";
import { ShipmentAvailableQuotes } from "../ShipmentAvailableQuotes/ShipmentAvailableQuotes";
import { SelectedQuoteActionButtons } from "../ShipmentsTable/SelectedQuoteActionButtons";

interface OrdersPricingCellProps extends CustomCellRendererProps {
  refreshData: () => void;
  setSnackBar: (snackBar: { open: boolean; message: string; severity: string }) => void;
}

export const OrdersPricingCell = React.memo((params: OrdersPricingCellProps) => {
  const { data, refreshData, setSnackBar } = params;

  const getTotalEstimatedShippingCost = (data: any): number => {
    let totalEstimatedShippingCost = 0;

    if (data.items && Array.isArray(data.items)) {
      data.items.forEach((item: any) => {
        if (item.unitEstimatedShippingCost) {
          totalEstimatedShippingCost += parseFloat(item.unitEstimatedShippingCost);
        }
      });
    }

    // Round to 2 decimal places and convert back to number
    return parseFloat(totalEstimatedShippingCost.toFixed(2));
  };

  const totalEstimatedShippingCost = getTotalEstimatedShippingCost(data);

  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="caption">Total Price:</Typography>
        <Typography variant="caption" color={globalTheme.primaryColor}>
          {`${data?.totalPrice}`}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="caption">Total Shipping Price:</Typography>
        <Typography variant="caption" color={globalTheme.primaryColor}>
          {`${data?.totalShippingPrice}`}
        </Typography>
      </Stack>

      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="caption">Est. Total Shipping Price:</Typography>
        <Typography variant="caption" color={globalTheme.primaryColor}>
          {`${totalEstimatedShippingCost}`}
        </Typography>
      </Stack>
    </Stack>
  );
});
